import type { ServiceHistoryListItem } from '@services';
import { CheckOutlined, ShopOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

interface IProps {
  item: ServiceHistoryListItem;
}

const statusConfig: Record<string, { color: string; label: string }> = {
  Umoto: { color: 'green', label: 'Umoto Verified' },
  Imported: { color: 'purple', label: 'Imported Entry' },
  Unverified: { color: 'orange', label: 'Unverified' },
};

const formatMileage = (mileage: number) =>
  new Intl.NumberFormat('en-GB').format(Math.round(mileage));

export const ServiceHistoryCard: React.FC<IProps> = ({ item }) => {
  const config = statusConfig[item.status] ?? { color: 'default', label: item.status };

  const openOrder = () => {
    if (item.orderId) {
      window.open(`/orders/${item.orderId}`, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      style={{
        background: '#fff',
        marginBottom: 16,
        padding: 20,
        borderRadius: 12,
        border: '1px solid #e2e8f0',
        position: 'relative',
      }}
    >
      {item.isOwnedByCurrentTenant && item.orderId && (
        <Button
          type="default"
          size="small"
          onClick={openOrder}
          style={{
            position: 'absolute',
            right: 20,
            top: 20,
            fontSize: 12,
            color: '#64748b',
          }}
        >
          View Job
        </Button>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
        <Tag color={config.color} style={{ fontWeight: 600, fontSize: 12 }}>
          {config.label}
        </Tag>
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          {dayjs(item.creationTime).format('DD/MM/YYYY')}
        </Typography.Text>
        <Typography.Text strong style={{ fontSize: 13 }}>
          • {formatMileage(item.mileage)} mi
        </Typography.Text>
      </div>

      {item.serviceNames && item.serviceNames.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: 10,
            padding: '12px 16px',
            background: '#f8fafc',
            borderRadius: 8,
          }}
        >
          {item.serviceNames.map((name) => (
            <div
              key={name}
              style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, color: '#334155' }}
            >
              <CheckOutlined style={{ color: '#10b981', fontWeight: 'bold' }} />
              {name}
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: 14, fontSize: 12, color: '#64748b', display: 'flex', alignItems: 'center', gap: 6 }}>
        {item.status === 'Unverified' ? (
          <>
            <UserOutlined />
            <span>User uploaded</span>
          </>
        ) : (
          <>
            <ShopOutlined />
            <span>Workshop: <strong style={{ color: '#0f172a' }}>{item.tenantName}</strong></span>
          </>
        )}
      </div>
    </div>
  );
};
